<template>
  <div class="liquor-life">
    <Header active="/liquor/life" />
    <NoContent />
    <Sticky />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import HeaderSelect from "@/components/liquor/HeaderSelect";
import Sticky from "@/components/liquor/Sticky";

import NoContent from "@/components/common/NoContent";

export default {
  name: "LiquorBrowser",
  components: {
    Header,
    HeaderSelect,
    NoContent,
    Sticky
  },
  data() {
    return {
      headerSelectArray: []
    };
  }
};
</script>

<style lang="scss">
.liquor-life {
  width: 100%;
  margin-top: 160px;
}
</style>

<style lang="scss" scoped>
.liquor-life {
  .liquor-header-parent {
    background: rgba(0, 0, 0, 1);
  }
}
</style>